import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingPage from "../LoadingPage";
import { NotFoundPage } from "~/pages";
import { CAMPAIGN_NOT_FOUND_PAGE_NAME } from "~/pages/NotFoundPage/notFoundRedirect";
import { buildCampaignRedirect } from "./campaignRedirect";

function ChooseCampaign() {
  const location = useLocation();
  const navigate = useNavigate();

  const [isLoaded, setLoaded] = useState(false);

  useEffect(() => {
    // resetting values once URL parameters have changed
    setLoaded(false);

    const destinationUrl = buildCampaignRedirect(location.search);
    if (destinationUrl) {
      navigate(destinationUrl);
      return;
    }
    console.error("Invalid or missing required parameters: cSource or expId.");

    setLoaded(true);
  }, [location.search]);

  if (!isLoaded) {
    return <LoadingPage />;
  }

  return (
    <NotFoundPage
      trackValue="Campaign Not Found Page|Home Button"
      pageName={CAMPAIGN_NOT_FOUND_PAGE_NAME}
    />
  );
}

export default ChooseCampaign;
